import { useMemo } from 'react';
import type { IFormilySchema } from '../types';
import { getNestedArrayTableFields } from '../components/form-array-table/getNestedArrayTableFields';
import NestedTablesRenderer from '../components/form-array-table/NestedTablesRenderer';

type RecordType = Record<string, unknown>;

export const useExpandableNestedTables = (childSchema?: IFormilySchema) => {
  const nestedFields = useMemo(
    () => getNestedArrayTableFields(childSchema),
    [childSchema]
  );
  const hasNestedTables = nestedFields.length > 0;

  const expandable = useMemo(() => {
    if (!hasNestedTables) return undefined;

    return {
      expandedRowRender: (record: RecordType) => (
        <NestedTablesRenderer record={record} childSchema={childSchema} />
      ),
      rowExpandable: (record: RecordType) =>
        nestedFields.some(({ key }) => {
          const value = record[key];
          return Array.isArray(value) && value.length > 0;
        }),
    };
  }, [hasNestedTables, childSchema, nestedFields]);

  return { expandable, nestedFields, hasNestedTables };
};
